import React, { useState } from 'react';
import MainImage from '../../images/portfolio/hogskolenvolda/HeroImage.jpg';
import PortfolioPage from '../../components/PortfolioPage';
import { useT } from '../../i18n';

const PortfolioHogskolenVolda = () => {
    const t = useT();
    return <PortfolioPage img={MainImage} url="https://player.vimeo.com/video/599572882" title={t("Søppelsortering - Høgskulen i Volda", "Waste sorting - Volda University College")} description={t(
      "I samarbeid med Høgskulen i Volda, har vi produsert en kort video som effektivt demonstrerer hva slags søppel som skal hives i hvilke beholdere. Hensikten er å vise filmen på en skjerm i lokalet til skolen, for å spre informasjon om hva som skal kastes hvor, når det kan være usikkerhet om dette for studenter. Prosjektet ble produsert i sommeren 2021. ",
      "Together with Volda University College, we produced a short video that clearly shows which kinds of waste go in which bins. The film was made to run on a screen on campus, helping students who might be unsure about what goes where. The project was produced in the summer of 2021."
    )} />
}

export default PortfolioHogskolenVolda;
